import { AppSettings } from 'app/sharedcomponents/_common/constants/app.constants';
import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Observable';
import { SendMoneyDetail, SendMoneySteps } from '../../models/sendmoney/sendmoney';
import { InfoPopupComponent } from '../../sharedcomponents/_directive/info-popup/info-popup.component';
import { SendMoneyService } from '../../_services/sendmoneyservice/sendmoneyservice';
import { Ng2DeviceService } from "ng2-device-detector";

@Component({
  selector: 'app-debitcard',
  templateUrl: './debitcard.component.html',
  styleUrls: ['./debitcard.component.css']
})
export class DebitcardComponent implements OnInit {
  sendMoneyDetail: SendMoneyDetail;
  PageFlow: any = {};
  constructor(private router: Router, private sendMoneyService: SendMoneyService, public translate: TranslateService, private vcRef: ViewContainerRef, private deviceService: Ng2DeviceService, private modal: Modal) {
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    this.PageFlow.Value = sessionStorage.PageFlow;
    if (this.sendMoneyDetail.pickupTypeDetails.countryName == undefined || this.sendMoneyDetail.pickupTypeDetails.countryName == '') {
      if (this.PageFlow.Value == 'repeatorder') {
        if (sessionStorage.RepeatOrderFlow != undefined && sessionStorage.RepeatOrderFlow != '') {
          this.router.navigate(['/' + sessionStorage.RepeatOrderFlow]);
        } else {
          this.router.navigate(['/repeatorderlist']);
        }
      } else {
        this.router.navigate(['/dashboard']);
      }
      return;
    }
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (this.sendMoneyDetail.isData == true && this.PageFlow.Value == 'sendmoney') {
      let _self=this;
      return Observable.create(observer => {
        this.modal.overlay.defaultViewContainer = this.vcRef;
        let modalData: any = {};
        let loading = false;
        modalData.Title = this.translate.instant('Common_lblConfirm');
        modalData.Message = this.translate.instant('SendMoney_navigateConfirmDesc');
        this.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(data => {
            if (modalData.next == 'yes') {
              let DeviceDetail = _self.deviceService.getDeviceInfo();
              (<any>window).firebase
                .analytics()
                .logEvent("UnfinishedTransaction", {
                  Screen: "PaymentType",
                  Platform: AppSettings.Platform,
                  Browser: DeviceDetail.browser,
                  OSVersion: DeviceDetail.os_version,
                  AppVersion: AppSettings.Appversion
                });
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          });
        });
      });
    }
    return true;
  }
  ngOnInit() {
    this.sendMoneyService.setModalPopup(SendMoneySteps.PaymentType);
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/debitcard/debitcard.component.ts